import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import FlightTabs from "../AllTabs/FlightTabs";
import SearchFlightPanel from "./SearchFlightPanel";
import AirlineOffers from "../Advertisements/AirlineOffers"; // Import the new component
import { useNavigate } from "react-router-dom";

const SearchFlight = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [currency, setCurrency] = useState(user?.currency);

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <FlightTabs pageName="SEARCH" />
              </div>
              <SearchFlightPanel />
            </div>
            <AirlineOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFlight;
